import * as React from 'react';
import * as  _ from 'lodash';
import withClickOutsideOnOverlay from '../../../../../hoc/withClickOutsideOnOverlay';
import ValidationForm from '../../../../forms/ValidationForm';
import PopupWrapper from '../../../../components/Popup/PopupWrapper';
import PopupHeader from '../../../../components/Popup/PopupHeader';
import PopupBody from '../../../../components/Popup/PopupBody';
import { okButtonClass, cancelButtonClass } from '../../../../../const/popupButtonClasses';
import { IProject } from '../../../../../models/IProject';
import { validateTagName } from '../../../../../services/validations/validateTagName';
import { getNextTagName } from '../../../../../services/mini/getNextTagName';

export interface IRemoveCiCdLinkParam {
    tagName: string;
}

type RemoveCiCdLinkAndSaveScriptsToTagFormProps = {
    project: IProject;
    onClose: () => void;
    onRemoveCiCdLink: (param: IRemoveCiCdLinkParam) => void;
}

class RemoveCiCdLinkAndSaveScriptsToTagForm extends React.Component<RemoveCiCdLinkAndSaveScriptsToTagFormProps> {

    validateTagName = ({ tagName }) => {
        return validateTagName(tagName, this.props.project);
    }

    getNextTagName() {
        const { project } = this.props;
        return getNextTagName(project);
    }

    saveWithVersion = ({ tagName }) => {
        this.props.onRemoveCiCdLink({ tagName });
    }

    saveWithoutVersion = ({ tagName }) => {
        this.props.onRemoveCiCdLink({ tagName: undefined });
    }

    cancel = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    render() {
        const confirmSaveCICDLabel = 'Save CI/CD state as a version';
        return <PopupWrapper className="remove-cicd-link-form">
            <PopupHeader
                title="Save CI/CD state as a version"
                onCancel={this.cancel}
            />
            <PopupBody>
                <div className="remove-cicd-link-form__body">
                    <div className="remove-cicd-link-form__body-info">
                        To save the <b>current CI/CD state</b> as a new version, enter a version name in the field below and click <b>{confirmSaveCICDLabel}</b>. Otherwise the scripts state will be reset to the "Last" version.
                    </div>
                    <br />
                    <br />

                    <ValidationForm
                        inputs={[
                            {
                                name: 'tagName',
                                label: 'Version name',
                                autoFocus: true,
                                maxLength: 50,
                                maxLengthMsg: `Max version length: 50 characters`,
                                value: this.getNextTagName(),
                                rules: [this.validateTagName],
                                applyOnEnter: true,
                            },
                        ]}
                        buttons={[
                            {
                                key: 'cancel',
                                label: 'Reset to the "Last"',
                                action: this.saveWithoutVersion,
                                className: cancelButtonClass,
                            },
                            {
                                key: 'ok',
                                label: confirmSaveCICDLabel,
                                action: this.saveWithVersion,
                                className: okButtonClass,
                            },
                        ]}
                        btnsClassName="popup-form_btns main-btns" />
                </div>
            </PopupBody>
        </PopupWrapper>;
    }
}

export default withClickOutsideOnOverlay(RemoveCiCdLinkAndSaveScriptsToTagForm);